import { NgModule, ModuleWithProviders } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CommonModule } from '@angular/common';
import { DndModule } from 'ng2-dnd';
import { AceEditorModule } from 'ng2-ace-editor';

/* Core */
import { CoreModule } from './core.module';

/* User */
import { LoginComponent } from '../../components/login/login.component';
import { RegisterComponent } from '../../components/register/register.component';
import { DashboardComponent } from '../../components/dashboard/dashboard.component';
import { ProfiloUtenteComponent } from '../../components/profilo-utente/profilo-utente.component';

/* Pratiche */
import { PraticheComponent } from '../../components/pratiche/pratiche.component';

/* Anagrafica */
import { AnagraficaComponent } from '../../components/anagrafica/anagrafica.component';
import { AnagraficaDettaglioComponent } from '../../components/anagrafica/anagrafica-dettaglio/anagrafica-dettaglio.component';
import { SituazioneContribuenteComponent } from '../../components/situazione-contribuente/situazione-contribuente.component';

/* Notifiche */
import { GestioneNotificheComponent } from '../../components/gestione-notifiche/gestione-notifiche.component';
import { NotificheImmissioneManualeComponent } from '../../components/gestione-notifiche/notifiche-immissione-manuale/notifiche-immissione-manuale.component';
import { NotificheRiepilogoComponent } from '../../components/gestione-notifiche/notifiche-riepilogo/notifiche-riepilogo.component';
import { NotificheImportazioneFileComponent } from '../../components/gestione-notifiche/notifiche-importazione-file/notifiche-importazione-file.component';

/* Pagamenti */
import { GestionePagamentiComponent } from '../../components/gestione-pagamenti/gestione-pagamenti.component';
import { PagamentiImmissioneManualeComponent } from '../../components/gestione-pagamenti/pagamenti-immissione-manuale/pagamenti-immissione-manuale.component';
import { PagamentiRiepilogoComponent } from '../../components/gestione-pagamenti/pagamenti-riepilogo/pagamenti-riepilogo.component';
import { PagamentiImportazioneFileComponent } from '../../components/gestione-pagamenti/pagamenti-importazione-file/pagamenti-importazione-file.component';

/* Rendicontazione */
import { StatisticheRendicondazioneComponent } from '../../components/statistiche-rendicondazione/statistiche-rendicondazione.component';
import { RendicontazioneGeneraleComponent } from '../../components/statistiche-rendicondazione/rendicontazione-generale/rendicontazione-generale.component';
import { StatisticheRiepilogoComponent } from '../../components/statistiche-rendicondazione/statistiche-riepilogo/statistiche-riepilogo.component';
import { StatisticheEmissioniComponent } from '../../components/statistiche-rendicondazione/statistiche-emissioni/statistiche-emissioni.component';
import { StatisticheRateComponent } from '../../components/statistiche-rendicondazione/statistiche-rate/statistiche-rate.component';
import { ListeCaricoComponent } from '../../components/statistiche-rendicondazione/liste-carico/liste-carico.component';
import { ListeCaricoIngiunzioniComponent } from '../../components/statistiche-rendicondazione/liste-carico/liste-carico-ingiunzioni/liste-carico-ingiunzioni.component';
import { ListeCaricoIntimazioniComponent } from '../../components/statistiche-rendicondazione/liste-carico/liste-carico-intimazioni/liste-carico-intimazioni.component';
import { RendicontazioneAnaliticoComponent } from '../../components/statistiche-rendicondazione/rendicontazione-generale/rendicontazione-analitico/rendicontazione-analitico.component';

/* Import massivi */
import { ImportMassiviComponent } from '../../components/import-massivi/import-massivi.component';
import { ImportaPraticheComponent } from '../../components/import-massivi/importa-pratiche/importa-pratiche.component';
import { ImportaAnagraficaComponent } from '../../components/import-massivi/importa-anagrafica/importa-anagrafica.component';
import { ImportaAssociatiComponent } from '../../components/import-massivi/importa-associati/importa-associati.component';
import { ImportaIntimazioniComponent } from '../../components/import-massivi/importa-intimazioni/importa-intimazioni.component';
import { ImportaNotificheComponent } from '../../components/import-massivi/importa-notifiche/importa-notifiche.component';
import { ImportaPostaliComponent } from '../../components/import-massivi/importa-postali/importa-postali.component';

/* Comune */
import { ImpostazioniComuneComponent } from '../../components/impostazioni-comune/impostazioni-comune.component';
import { InteressiComponent } from '../../components/impostazioni-comune/interessi/interessi.component';
import { DirittiOneriComponent } from '../../components/impostazioni-comune/diritti-oneri/diritti-oneri.component';
import { MessiNotificatoriComponent } from '../../components/impostazioni-comune/messi-notificatori/messi-notificatori.component';
import { FlussoPraticaComponent } from '../../components/impostazioni-comune/flusso-pratica/flusso-pratica.component';
import { TipiNotificaComponent } from '../../components/impostazioni-comune/parametri-generali/tipi-notifica/tipi-notifica.component';
import { CanaliPagamentoComponent } from '../../components/impostazioni-comune/canali-pagamento/canali-pagamento.component';
import { TemplateComponent } from '../../components/template/template.component';

/* Sistema */
import { SistemaComponent } from '../../components/sistema/sistema.component';
import { GestioneStatiComponent } from '../../components/sistema/gestione-stati/gestione-stati.component';
import { GestioneComuniComponent } from '../../components/sistema/gestione-comuni/gestione-comuni.component';
import { OperatoriPermessiComponent } from '../../components/sistema/utenti-permessi/operatori-permessi/operatori-permessi.component';
import { CittadiniPermessiComponent } from '../../components/sistema/utenti-permessi/cittadini-permessi/cittadini-permessi.component';
import { UtentiPermessiComponent } from '../../components/sistema/utenti-permessi/utenti-permessi.component';
import { GestioneRuoliComponent } from '../../components/sistema/gestione-ruoli/gestione-ruoli.component';
import { PermessiUtentiComponent } from '../../components/impostazioni-comune/permessi-utenti/permessi-utenti.component';
import { UtentiPermessiDettaglioComponent } from '../../components/sistema/utenti-permessi/utenti-permessi-dettaglio/utenti-permessi-dettaglio.component';

import { GestioneGruppiTemplatesComponent } from '../../components/sistema/gestione-gruppi-templates/gestione-gruppi-templates.component';
import { BackendComponent } from '../../components/backend/backend.component';
import { ParametriGeneraliComponent } from '../../components/impostazioni-comune/parametri-generali/parametri-generali.component';
import { TipiFasiComponent } from '../../components/impostazioni-comune/parametri-generali/tipi-fasi/tipi-fasi.component';
import { TipiTributiComponent } from '../../components/impostazioni-comune/parametri-generali/tipi-tributi/tipi-tributi.component';
import { TipiLegamiComponent } from '../../components/impostazioni-comune/parametri-generali/tipi-legami/tipi-legami.component';
import { TipiSpedizioniComponent } from '../../components/impostazioni-comune/parametri-generali/tipi-spedizioni/tipi-spedizioni.component';

import { AuthGuard } from '../../guards/auth.guard';

import { routing } from './riscossione-coattiva.routing';

@NgModule({
  imports: [
  routing,
    CommonModule,
    CoreModule,
    DndModule.forRoot(),
    AceEditorModule,
  ],
  declarations: [
    LoginComponent,
    RegisterComponent,
    DashboardComponent,
    ProfiloUtenteComponent,
    PraticheComponent,
    AnagraficaComponent,
    AnagraficaDettaglioComponent,
    SituazioneContribuenteComponent,
    GestioneNotificheComponent,
    NotificheImmissioneManualeComponent,
    NotificheRiepilogoComponent,
    NotificheImportazioneFileComponent,
    GestionePagamentiComponent,
    PagamentiImmissioneManualeComponent,
    PagamentiRiepilogoComponent,
    PagamentiImportazioneFileComponent,
    StatisticheRendicondazioneComponent,
    ImportMassiviComponent,
    ImportaAssociatiComponent,
    ImportaIntimazioniComponent,
    ImportaNotificheComponent,
    ImportaPostaliComponent,
    ImportaPraticheComponent,
    ImpostazioniComuneComponent,
    InteressiComponent,
    DirittiOneriComponent,
    MessiNotificatoriComponent,
    FlussoPraticaComponent,
    TipiNotificaComponent,
    CanaliPagamentoComponent,
    TemplateComponent,
    SistemaComponent,
    GestioneStatiComponent,
    GestioneComuniComponent,
    OperatoriPermessiComponent,
	CittadiniPermessiComponent,
    UtentiPermessiComponent,
    GestioneRuoliComponent,
    PermessiUtentiComponent,
    UtentiPermessiDettaglioComponent,
    GestioneGruppiTemplatesComponent,
    BackendComponent,
    ParametriGeneraliComponent,
    TipiFasiComponent,
    TipiTributiComponent,
    TipiLegamiComponent,
    TipiSpedizioniComponent,
    RendicontazioneGeneraleComponent,
    StatisticheRiepilogoComponent,
    StatisticheEmissioniComponent,
    StatisticheRateComponent,
    ListeCaricoComponent,
    ListeCaricoIngiunzioniComponent,
    ListeCaricoIntimazioniComponent,
    RendicontazioneAnaliticoComponent,
    ImportaAnagraficaComponent,
  ],
  exports: [
    CommonModule,
    CoreModule,
    LoginComponent,
    RegisterComponent,
    DashboardComponent,
    ProfiloUtenteComponent,
    PraticheComponent,
    AnagraficaComponent,
    AnagraficaDettaglioComponent,
    SituazioneContribuenteComponent,
    GestioneNotificheComponent,
    NotificheImmissioneManualeComponent,
    NotificheRiepilogoComponent,
    NotificheImportazioneFileComponent,
    GestionePagamentiComponent,
    PagamentiImmissioneManualeComponent,
    PagamentiRiepilogoComponent,
    PagamentiImportazioneFileComponent,
    StatisticheRendicondazioneComponent,
    ImportMassiviComponent,
    ImportaAssociatiComponent,
    ImportaIntimazioniComponent,
    ImportaNotificheComponent,
    ImportaPostaliComponent,
    ImportaPraticheComponent,
    ImpostazioniComuneComponent,
    InteressiComponent,
    DirittiOneriComponent,
    MessiNotificatoriComponent,
    FlussoPraticaComponent,
    TipiNotificaComponent,
    CanaliPagamentoComponent,
    TemplateComponent,
    SistemaComponent,
    GestioneStatiComponent,
    GestioneComuniComponent,
    OperatoriPermessiComponent,
    CittadiniPermessiComponent,
    UtentiPermessiComponent,
    GestioneRuoliComponent,
    PermessiUtentiComponent,
    UtentiPermessiDettaglioComponent,
    GestioneGruppiTemplatesComponent,
    BackendComponent,
    ParametriGeneraliComponent,
    TipiFasiComponent,
    TipiTributiComponent,
    TipiLegamiComponent,
    TipiSpedizioniComponent,
    RendicontazioneGeneraleComponent,
    StatisticheRiepilogoComponent,
    StatisticheEmissioniComponent,
    StatisticheRateComponent,
    ListeCaricoComponent,
    ListeCaricoIngiunzioniComponent,
    ListeCaricoIntimazioniComponent,
    RendicontazioneAnaliticoComponent,
    ImportaAnagraficaComponent,
	],
})
export class RiscossioneCoattivaModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: RiscossioneCoattivaModule,
            providers: [AuthGuard],
        };
    }
}
